module.exports = __webpack_public_path__ + "img/Douwe Spaanderman.1369cf9f.jpg";